import { render, staticRenderFns } from "./MyProfileUserLimits.vue?vue&type=template&id=0cb2f943&scoped=true"
import script from "./MyProfileUserLimits.vue?vue&type=script&lang=js"
export * from "./MyProfileUserLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2f943",
  null
  
)

export default component.exports